import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-92c952f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-pldege-wrap"
};
const _hoisted_2 = {
  class: "loan-center-wrap"
};
const _hoisted_3 = {
  class: "loan-center-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_banner = _resolveComponent("banner");
  const _component_tab = _resolveComponent("tab");
  const _component_question = _resolveComponent("question");
  const _component_loan_video = _resolveComponent("loan-video");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_banner), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_tab, {
    name: $setup.activeTab
  }, null, 8, ["name"]), (_openBlock(), _createBlock(_resolveDynamicComponent($setup.activeTab)))])]), _createVNode(_component_question), _createVNode(_component_loan_video, {
    visible: $setup.isOpenVideo
  }, null, 8, ["visible"])]);
}